<template>
	<div class="zhaopin">
		<div class="zpn_pc" v-if="!isPhone">
			<div class="collapse_box">
				<ul class="col_list">
					<li class="col_item flex1" v-for="item in gwlist" :key="item.id" @click="toDetail(item)">
						<div class="col_item_left">
							<p class="col_date">{{item.ri}}</p>
							<p class="col_month">{{item.nianyue}}</p>
						</div>
						<div class="col_item_right">
							<p class="cort_p1">{{item.title}}</p>
							<p class="cort_p2">{{ item.desc }}</p>
						</div>
					</li>
				</ul>
				<div class="fenye flex2">
					<pagination1 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
						@page-change="handlePageChange" />
				</div>
			</div>
		</div>
		<div class="zpn_ph" v-if="isPhone">
			<div class="collapse_box">
				<ul class="col_list">
					<li class="col_item flex1" v-for="item in gwlist" :key="item.id" @click="toDetail(item)">
						<div class="col_item_left">
							<p class="col_date">{{item.ri}}</p>
							<p class="col_month">{{item.nianyue}}</p>
						</div>
						<div class="col_item_right">
							<p class="cort_p1 ellip">{{item.title}}</p>
							<p class="cort_p2 ellip3">{{ item.desc }}</p>
						</div>
					</li>
				</ul>
				<div class="fenye flex2">
					<pagination2 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
						@page-change="handlePageChange" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination1 from "../../components/pagination1.vue";
import pagination2 from "../../components/pagination2.vue";
export default {
	components: {
		pagination1,
		pagination2,
	},
	data() {
		return {
			gwlist: [],
			currentPage: 1,
			totalPage: 0,
			totalNum: 0,
			isPhone: this.$isMobile,
		}
	},
	created() {
		this.hire();
	},
	methods: {
		async hire() {
			var data = {
				page: this.currentPage - 1,
				nums: 10
			}
			const res = await this.$api.hire(data);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 10);
				if (res.data.length) {
					this.gwlist = res.data;
					for (let i = 0; i < this.gwlist.length; i++) {
						this.gwlist[i].nianyue = this.gwlist[i].addtime.slice(0, 7);
						this.gwlist[i].ri = this.gwlist[i].addtime.slice(8, 10);
					}
				}
			}
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.hire();
		},
		toDetail(item) {
			this.$router.push("/joinUs/jobDetail?id=" + item.id);
		},
	}
}
</script>

<style lang="scss">
.zhaopin {
	.zpn_pc {
		.collapse_box {
			margin-top: 45px;
			.col_list {
				.col_item {
					padding: 10px 40px;
					background-color: #f9f9f9;
					margin-bottom: 25px;
					cursor: pointer;
					.col_item_left {
						border-right: 1px solid #ddd9d9;
						padding-right: 25px;
						.col_date {
							font-size: 50px;
							color: #4b4b4b;
						}
						.col_month {
							font-size: 16px;
							color: #4b4b4b;
						}
					}
					.col_item_right {
						flex: 1;
						padding-left: 30px;
						.cort_p1 {
							color: #4b4b4b;
							font-size: 20px;
							&:hover {
								color: #003f99;
							}
						}
						.cort_p2 {
							margin-top: 10px;
							font-size: 16px;
							color: #9d9d9d;
							line-height: 1.5;
							&:hover {
								color: #003f99;
							}
						}
					}
				}
			}
			.fenye {
				margin-top: 60px;
			}
		}
	}
	.zpn_ph {
		.collapse_box {
            padding: 0.35rem;
			.col_list {
				.col_item {
					padding: 0.3rem 0.5rem;
					background-color: #f9f9f9;
					margin-bottom: 0.5rem;
					cursor: pointer;
					.col_item_left {
						border-right: 1px solid #ddd9d9;
						padding-right: 0.5rem;
						.col_date {
							font-size: 0.8rem;
							color: #4b4b4b;
                            text-align: center;
						}
						.col_month {
							font-size: 0.38rem;
							color: #4b4b4b;
						}
					}
					.col_item_right {
						flex: 1;
                        width: 0;
						padding-left: 0.6rem;
						.cort_p1 {
							color: #4b4b4b;
							font-size: 0.4rem;
							&:hover {
								color: #003f99;
							}
						}
						.cort_p2 {
							margin-top: 0.24rem;
							font-size: 0.36rem;
							color: #9d9d9d;
							line-height: 1.5;
							&:hover {
								color: #003f99;
							}
						}
					}
				}
			}
			.fenye {
				margin-top: 0.5rem;
			}
		}
	}
}
</style>